import { NavLink, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isPosAllowed } from "../../../utils/companyCapabilities";

const ProductManagement = () => {
  const location = useLocation();
  const posAllowed = isPosAllowed(useSelector((state) => state.auth.profileData));

  const isProductActive =
    location.pathname.startsWith("/items") ||
    location.pathname.startsWith("/categories") ||
    location.pathname.startsWith("/Add-ons") ||
    location.pathname.startsWith("/Food-menu") ||
    location.pathname.startsWith("/CategoryTypes") ||
    location.pathname.startsWith("/Departments") ||
    location.pathname.startsWith("/discount") ||
    location.pathname.startsWith("/deal") ||
    location.pathname.startsWith("/voucher") ||
    location.pathname.startsWith("/supplier") ||
    location.pathname.startsWith("/recipes") ||
    location.pathname.startsWith("/batches") ||
    location.pathname.startsWith("/media");
  return (
    <div
      className={`menu-item has-sub ${isProductActive ? "active" : ""}`}
    >
      {/* Product Management Sidebar */}
      <div className="menu-link">
        <div className="menu-icon">
          <i className="fa-solid fa-utensils"></i>
        </div>
        <div className="menu-text">Item Catalog</div>
        <div className="menu-caret"></div>
      </div>
      <div className="menu-submenu">
        <div
          className={`menu-item ${location.pathname.startsWith("/items") ? "active" : ""}`}
        >
          <NavLink to="/items/manageItems" className="menu-link">
            Items
          </NavLink>
        </div>
        <div
          className={`menu-item ${location.pathname.startsWith("/categories") ? "active" : ""}`}
        >
          <NavLink to="/categories/manageCategories" className="menu-link">
            Categories
          </NavLink>
        </div>
        <div
          className={`menu-item ${location.pathname.startsWith("/media") ? "active" : ""}`}
        >
          <NavLink to="/media/manageMedia" className="menu-link">
            Media
          </NavLink>
        </div>
        <div
          className={`menu-item ${location.pathname.startsWith("/Add-ons") ? "active" : ""}`}
        >
          <NavLink to="/Add-ons/Add-onsGroups" className="menu-link">
            Add-on Groups
          </NavLink>
        </div>
        <div
          className={`menu-item ${location.pathname.startsWith("/Food-menu") ? "active" : ""}`}
        >
          <NavLink to="/Food-menu/manageFoodMenu" className="menu-link">
            Food Menus
          </NavLink>
        </div>
        <div
          className={`menu-item ${location.pathname.startsWith("/CategoryTypes") ? "active" : ""}`}
        >
          <NavLink to="/CategoryTypes" className="menu-link">
            Category Types
          </NavLink>
        </div>
        <div
          className={`menu-item ${location.pathname.startsWith("/Departments") ? "active" : ""}`}
        >
          <NavLink to="/Departments" className="menu-link">
            Food Groups
          </NavLink>
        </div>
        <div
          className={`menu-item ${location.pathname.startsWith("/discount") ? "active" : ""}`}
        >
          <NavLink to="/discount/manageDiscount" className="menu-link">
            Discounts
          </NavLink>
        </div>
        <div
          className={`menu-item ${location.pathname.startsWith("/deal") ? "active" : ""}`}
        >
          <NavLink to="/deal/manageDeals" className="menu-link">
            Combo Deals
          </NavLink>
        </div>
        {posAllowed && (
        <div
          className={`menu-item ${location.pathname.startsWith("/recipes") ? "active" : ""}`}
        >
          <NavLink to="/recipes/manageRecipes" className="menu-link">
            Manage Recipes
          </NavLink>
        </div>
        )}
        {posAllowed && (
        <div
          className={`menu-item ${location.pathname.startsWith("/batches") ? "active" : ""}`}
        >
          <NavLink to="/batches/manageBatch" className="menu-link">
            Manage Batch
          </NavLink>
        </div>
        )}
           
        <div
          className={`menu-item ${location.pathname.startsWith("/voucher") ? "active" : ""}`}
        >
          <NavLink to="/voucher/manageVoucher" className="menu-link">
            Vouchers
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default ProductManagement;